import {useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import globalMasehtot from "../masehtot.json";
import {collection, getDocs, query, where} from "firebase/firestore";
import {db} from "../../index";
import Cookies from "js-cookie";
import UserProgress from "../userStatus/userProgress";
import SiumProgress from "../niulSium/siumStatus/siumProgress";
import ConfettiComponent from "../userStatus/confetti";
import PrintMasehtot from "../niulSium/siumStatus/printMasehtot";
import Spinner from "../../spinner";


const DisplaySiumDetails = () => {

    const params = useParams();
    const [sium, setSium] = useState([]);
    const [pagesWereTaken, setPagesWereTaken] = React.useState(1000000);
    const [pagesWereLearned, setPagesWereLearned] = React.useState(0);
    const [siumChapters, setSiumChapters] = React.useState();
    const [siumUsers, setSiumUsers] = React.useState();
    const [siumStatus, setSiumStatus] = React.useState();
    const [usersList, setUsersList] = React.useState();
    const [checkUserDetails, setCheckUserDetails] = React.useState([]);
    const [learningListSorting, setLearningListSorting] = useState("status");
    const [sortDirection, setSortDirection] = useState("asc"); // asc or desc
    const [searchQuery, setSearchQuery] = useState("");
    const [isAdmin, setIsAdmin] = React.useState(false);
    const [printMode, setPrintMode] = useState(false);
    const [filterStillFree, setFilterStillFree] = useState(false);
    const [filterNotLearnedYet, setFilterNotLearnedYet] = useState(false);
    const [activeTab, setActiveTab] = useState("takenMasehtot"); // "takenMasehtot" or "learningStatus"
    const navigate = useNavigate();

    function handleSiumChapters(siumStatus, usersList, showStillFree = false, showNotLearnedYet = false) {
        if (!siumStatus) return;
        const chaptersNames = globalMasehtot.allChapters;
        const masehtotList = Object.entries(siumStatus)
            .filter(([masehetKey, masehet]) => {
                const totalChapters = masehet.totalChapters;
                const takenChapters = masehet.chapters.filter((chapter) => chapter.user).length;
                const learnedChapters = masehet.chapters.filter((chapter) => chapter.wasLearned).length;

                const allTaken = totalChapters === takenChapters;
                const allLearned = totalChapters === learnedChapters;

                if (!showStillFree && !showNotLearnedYet) return true;
                if (showStillFree && allTaken) return false;
                if (showNotLearnedYet && allLearned) return false;

                return true;
            })
            .map(([masehetKey, masehet]) => {
            const currentMasehet = globalMasehtot.allMasehtot[masehetKey];
            const allTaken = masehet.totalChapters === masehet.chapters.filter((chapter) => chapter.user).length;
            const partialMasehetWasTaken = masehet.chapters.some((chapter) => chapter.user);
            const allLearned = masehet.totalChapters === masehet.chapters.filter((chapter) => chapter.wasLearned).length;
            const totalChapters = masehet.totalChapters;
            const takenChapters = masehet.chapters.filter((chapter) => chapter.user).length;
            const learnedChapters = masehet.chapters.filter((chapter) => chapter.wasLearned).length;

            return (<div className="accordion-item" id={masehetKey + "-Masehet"}>
                <h3 className="accordion-header">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target={"#collapseTaken" + masehetKey} aria-expanded="false" aria-controls={"collapseTaken" + masehetKey}>
                        <span className="masehet-title">{currentMasehet.name}</span>
                        {currentMasehet.isMishna && <span className="badge bg-success margin-right-10">משנה</span>}
                        {!allTaken && <span className="badge bg-info margin-right-10">{totalChapters} / {takenChapters} פרקים נלקחו</span>}
                        {allTaken && <span className="badge bg-info margin-right-10">המסכת נתפסה</span>}
                        {!allLearned && !allTaken && <span className="badge bg-primary margin-right-10">{learnedChapters} נלמדו</span>}
                        {!allLearned && allTaken && <span className="badge bg-primary margin-right-10">{totalChapters} / {learnedChapters} פרקים נלמדו</span>}
                        {allLearned && <span className="badge bg-primary margin-right-10">הדרן עלך</span>}
                    </button>
                </h3>
                <div id={"collapseTaken" + masehetKey} className="accordion-collapse collapse" data-bs-parent="#takenMasehtotList">
                    <div className="accordion-body">
                        <div>
                            {masehet.chapters.map((chapter, c_i) => {
                                const wasTaken = chapter.user;
                                const wasLearned = chapter.wasLearned;
                                const chapterId = `${masehetKey}-${c_i}`;
                                const chapterName = chaptersNames[c_i];
                                const userKey = wasTaken ? chapter.user : null;
                                const userObj = wasTaken ? usersList[userKey] : null;
                                if (wasTaken) {
                                    userObj.key = userKey;
                                }
                                return (
                                    <>
                                        {wasLearned && <button type="button" className="btn btn-primary status-taken-button" id={chapterId} key={"shas-status-"+chapterId}
                                                               onClick={() => setCheckUserDetails(userObj)} data-bs-toggle="modal" data-bs-target="#checkUserModal">{chapterName}</button>}
                                        {!wasLearned && wasTaken && <button type="button" className="btn btn-info status-taken-button" id={chapterId}  key={"shas-status-"+chapterId}
                                                                            onClick={() => setCheckUserDetails(userObj)} data-bs-toggle="modal" data-bs-target="#checkUserModal">{chapterName}</button>}
                                        {!wasLearned && !wasTaken && <button type="button" className="btn btn-outline-secondary" id={chapterId} key={"shas-status-"+chapterId}
                                                                             data-bs-toggle="modal" data-bs-target="#addUserModal">{chapterName}</button>}
                                    </>);
                            })}
                            <div className="accordion-item margin-top-20" id={masehetKey + "-Masehet-dapim"}>
                                <h3 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                            data-bs-target={"#collapseTaken" + masehetKey + "Dapim"} aria-expanded="false" aria-controls={"collapseTaken" + masehetKey + "Dapim"}>
                                        פירוט דפי המסכת
                                    </button>
                                </h3>
                                <div id={"collapseTaken" + masehetKey + "Dapim"} className="accordion-collapse collapse" data-bs-parent={`#${masehetKey}-Masehet-dapim`}>
                                    <div className="accordion-body perut-dapim-container">
                                        {masehet.chapters.map((chapter, c_i) => {
                                            const wasTaken = chapter.user;
                                            const wasLearned = chapter.wasLearned;
                                            const chapterId = `${masehetKey}-${c_i}`;
                                            const chapterName = chaptersNames[c_i];
                                            const userKey = wasTaken ? chapter.user : null;
                                            const userObj = wasTaken ? usersList[userKey] : null;
                                            if (wasTaken) {
                                                userObj.key = userKey;
                                            }
                                            return (
                                                <React.Fragment key={masehetKey + c_i + "-perut-dapim"}>
                                                    <div>
                                                        {wasLearned && <button type="button" className="btn btn-primary status-taken-button perut-dapim-perek" id={chapterId} key={"perut-"+chapterId}
                                                                               onClick={() => setCheckUserDetails(userObj)} data-bs-toggle="modal" data-bs-target="#checkUserModal">{chapterName}</button>}
                                                        {!wasLearned && wasTaken && <button type="button" className="btn btn-info status-taken-button perut-dapim-perek" id={chapterId} key={"perut-"+chapterId}
                                                                                            onClick={() => setCheckUserDetails(userObj)} data-bs-toggle="modal" data-bs-target="#checkUserModal">{chapterName}</button>}
                                                        {!wasLearned && !wasTaken && <button type="button" className="btn btn-outline-secondary perut-dapim-perek" id={chapterId} key={"perut-"+chapterId}
                                                                                             data-bs-toggle="modal" data-bs-target="#addUserModal">{chapterName}</button>}
                                                    </div>
                                                    <div className="perut-dapim-list">
                                                        {chapter.pages?.map((page, p_i) => {
                                                            const pageId = `${masehetKey}-${c_i}-${p_i}`;
                                                            return(<React.Fragment key={"perut-"+pageId}>
                                                                {page.learned && <button type="button" className="btn btn-primary status-taken-button daf-button-little" id={pageId}
                                                                                         onClick={() => setCheckUserDetails(userObj)} data-bs-toggle="modal" data-bs-target="#checkUserModal">{page.pageName}</button>}
                                                                {!page.learned && wasTaken && <button type="button" className="btn btn-info status-taken-button daf-button-little" id={pageId}
                                                                                                      onClick={() => setCheckUserDetails(userObj)} data-bs-toggle="modal" data-bs-target="#checkUserModal">{page.pageName}</button>}
                                                                {!page.learned && !wasTaken && <button type="button" className="btn btn-outline-secondary daf-button-little" id={pageId}
                                                                                                       data-bs-toggle="modal" data-bs-target="#addUserModal">{page.pageName}</button>}
                                                            </React.Fragment>);
                                                        })}
                                                        {chapter.mishnayot?.map((mishna, p_i) => {
                                                            const pageId = `${masehetKey}-${c_i}-${p_i}`;
                                                            return(<React.Fragment key={"perut-"+pageId}>
                                                                {mishna.learned && <button type="button" className="btn btn-primary status-taken-button mishna-button-little" id={pageId}
                                                                                           onClick={() => setCheckUserDetails(userObj)} data-bs-toggle="modal" data-bs-target="#checkUserModal">{mishna.mishnaName}</button>}
                                                                {!mishna.learned && wasTaken && <button type="button" className="btn btn-info status-taken-button mishna-button-little" id={pageId}
                                                                                                        onClick={() => setCheckUserDetails(userObj)} data-bs-toggle="modal" data-bs-target="#checkUserModal">{mishna.mishnaName}</button>}
                                                                {!mishna.learned && !wasTaken && <button type="button" className="btn btn-outline-secondary mishna-button-little" id={pageId}
                                                                                                         data-bs-toggle="modal" data-bs-target="#addUserModal">{mishna.mishnaName}</button>}
                                                            </React.Fragment>);
                                                        })}
                                                    </div>
                                                </React.Fragment>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {partialMasehetWasTaken && <div className="lomdim-list-container card" id={masehetKey + "Lomdim"}>
                            <span className="card-header">רשימת הלומדים:</span>
                            <ul className="lomdim-list list-group list-group-flush">
                                {masehet.usersList.map((userId) => {
                                    return (<li key={userId} className="list-group-item">{usersList[userId].name}</li>)
                                })}
                            </ul>
                        </div>}
                    </div>
                </div>
            </div>);
        });
        return masehtotList;
    }

    function getLastModifiedInDays(lastModifed) {
        const date = new Date(lastModifed.seconds * 1000);
        const mSecInDay = 24 * 60 * 60 * 1000;
        const days = Math.floor((Date.now() - date.getTime()) / mSecInDay);
        return days;
    }

    function displayUserMasehtot(user, uIndex) {
        return user.masehtot
            .sort((a, b) => globalMasehtot.allMasehtot[a.masehetKey].index - globalMasehtot.allMasehtot[b.masehetKey].index)
            .map((masehet) => {
                const key = "user" + uIndex + "-masehet" + masehet.masehetKey;
                const chaptersFinished = masehet.chapters.filter((chapter) => {
                    const chapterIndex = parseInt(Object.keys(chapter)[0]);
                    return chapter[chapterIndex]; // Check if the chapter is marked as finished (true)
                }).length;
                return <div className="accordion-item" key={key}>
                    <h3 className="accordion-header">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target={"#collapse" + key} aria-expanded="false" aria-controls={"collapse" + key}>
                            {globalMasehtot.allMasehtot[masehet.masehetKey].name}
                            {globalMasehtot.allMasehtot[masehet.masehetKey].isMishna && <span className="badge bg-success margin-right-10">משנה</span>}
                            <span className="badge bg-primary margin-right-10">
                            {masehet.chapters.length} / {chaptersFinished} פרקים נלמדו
                        </span>
                        </button>
                    </h3>
                    <div id={"collapse" + key} className="accordion-collapse collapse" data-bs-parent="#masehtotList">
                        <div className="accordion-body chapters-list">
                            <br/>
                            {masehet.chapters
                                .sort((a, b) => parseInt(Object.keys(a)[0]) - parseInt(Object.keys(b)[0]))
                                .map((chapter) => {
                                    const chapterIndex = parseInt(Object.keys(chapter)[0]);
                                    const cKey = key + "-chapter" + chapterIndex;
                                    const wasFinished = chapter[chapterIndex];
                                    return (<>
                                        <input type="checkbox" className="btn-check" id={cKey + "btn"} checked={wasFinished} disabled/>
                                        <label className="btn btn-outline-primary chapter-button" htmlFor={cKey + "btn"}>{globalMasehtot.allChapters[chapterIndex]}</label>
                                    </>);
                                })}
                        </div>
                    </div>
                </div>
            });
    }

    // Handle sort change with direction toggle
    const handleSortChange = (sortType) => {
        if (learningListSorting === sortType) {
            // Toggle direction if same sort type
            const newDirection = sortDirection === "asc" ? "desc" : "asc";
            setSortDirection(newDirection);
            setSiumUsers(handleLearningList(siumStatus, usersList, sortType, newDirection, searchQuery));
        } else {
            // New sort type, reset to ascending
            setLearningListSorting(sortType);
            setSortDirection("asc");
            setSiumUsers(handleLearningList(siumStatus, usersList, sortType, "asc", searchQuery));
        }
    };

    // Handle masehtot filter changes
    const handleMasehtotFilterChange = (filterType, value) => {
        let newFilterStillFree = filterStillFree;
        let newFilterNotLearnedYet = filterNotLearnedYet;

        if (filterType === 'stillFree') {
            newFilterStillFree = value;
            setFilterStillFree(value);
        } else if (filterType === 'notLearnedYet') {
            newFilterNotLearnedYet = value;
            setFilterNotLearnedYet(value);
        }

        setSiumChapters(handleSiumChapters(siumStatus, usersList, newFilterStillFree, newFilterNotLearnedYet));
    };

    // Handle search
    const handleSearch = (query) => {
        setSearchQuery(query);
        setSiumUsers(handleLearningList(siumStatus, usersList, learningListSorting, sortDirection, query));
    };

    function handleLearningList(siumStatus, usersList, sorting, direction = "asc", search = "") {
        const searchLower = search.toLowerCase();

        const learningList = (Object.entries(usersList)
            .filter(([, user]) => {
                if (!search.trim()) return true;
                return (
                    user.name?.toLowerCase().includes(searchLower) ||
                    user.phone?.toLowerCase().includes(searchLower) ||
                    user.email?.toLowerCase().includes(searchLower)
                );
            })
            .sort(([, a], [, b]) => {
                let result = 0;
                if (sorting === "status") {
                    const aStatus = (a.userPagesLearned * 100) / a.userPagesTaken || 0;
                    const bStatus = (b.userPagesLearned * 100) / b.userPagesTaken || 0;
                    result = aStatus - bStatus;
                } else if (sorting === "date") {
                    result = a.lastModified - b.lastModified;
                } else if (sorting === "name") {
                    result = a.name.localeCompare(b.name, 'he');
                }
                return direction === "desc" ? -result : result;
            })
            .map(([userId, user], u_index) => {

                return(<div className="accordion-item" key={u_index + "-learningList"}>
                    <h3 className="accordion-header">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target={"#collapseLearning" + u_index} aria-expanded="false"
                                aria-controls={"collapseLearning" + u_index}>
                            {user.name}
                            {sorting === "status" && <>
                                <span className="badge bg-info margin-right-10">{Math.floor((user.userPagesLearned * 100) / user.userPagesTaken)}%</span>
                                <span className="badge bg-primary margin-right-10">{user.userPagesTaken} / {user.userPagesLearned} דפים נלמדו</span>
                            </>}
                            {sorting === "date" && <>
                                <span className="badge bg-info margin-right-10">לפני {user.lastModified} ימים</span>
                                <span className="badge bg-primary margin-right-10">{user.userPagesTaken} / {user.userPagesLearned} דפים נלמדו</span>
                            </>}
                            {sorting === "name" && <>
                                <span className="badge bg-info margin-right-10">{Math.floor((user.userPagesLearned * 100) / user.userPagesTaken)}%</span>
                                <span className="badge bg-primary margin-right-10">{user.userPagesTaken} / {user.userPagesLearned} דפים נלמדו</span>
                            </>}
                        </button>
                    </h3>
                    <div id={"collapseLearning" + u_index} className="accordion-collapse collapse"
                         data-bs-parent="#learningUsersList">
                        <div className="accordion-body">
                            <UserProgress userPerc={Math.floor((user.userPagesLearned * 100) / user.userPagesTaken)}
                                          recommendation={user.recommendedPercent}/>
                            <div className="user-detail-modal mt-2 check-user-modal">
                                <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
                                    <title>COUNTDOWN TIMER</title>
                                    <path d="M64,12.75a51.186,51.186,0,0,0-37.2,16l-1.059-7.918a1.25,1.25,0,0,0-2.479.332L24.68,31.773a1.251,1.251,0,0,0,1.239,1.084h9.807a1.25,1.25,0,0,0,0-2.5h-7a48.594,48.594,0,1,1-6.729,8.887,1.25,1.25,0,1,0-2.152-1.271A51.256,51.256,0,1,0,64,12.75Z"/><path d="M94.009,86.526a1.249,1.249,0,0,0,1.741-.306,38.764,38.764,0,1,0-7.2,7.759,1.25,1.25,0,0,0-1.586-1.934A36.218,36.218,0,1,1,93.7,84.785,1.25,1.25,0,0,0,94.009,86.526Z"/><path d="M62.75,38.356v24.4l-17.361.094a1.25,1.25,0,0,0,.007,2.5H45.4l18.6-.1A1.25,1.25,0,0,0,65.25,64V38.356a1.25,1.25,0,0,0-2.5,0Z"/>
                                </svg>
                                <span>לומד עדכן מצב למידה לפני {user.lastModified} ימים</span>
                            </div>
                            <div className="accordion margin-top-20" id="learningMasehtotList">
                                {displayUserMasehtot(user, u_index)}
                            </div>
                        </div>
                    </div>
                </div>);
            }));
        return learningList;
    }

    function shareLomdimLoginPage() {
        if (navigator.share) {
            navigator.share({
                title: 'סיום הש"ס של "' + sium.kehilaName + '"',
                text: 'סיום הש"ס של "' + sium.kehilaName + '" - כניסה ללומדים',
                url: '/lomdimLogin/' + sium.id
            });
        }
    }

    useEffect(() => {
        setTimeout(() => {
            const buttons = document.querySelectorAll('.sium-status-option');

            buttons.forEach(button => {
                button.addEventListener('click', function() {
                    const buttons = document.querySelectorAll('.sium-status-option');
                    buttons.forEach(button => {
                        button.style.backgroundColor = '';
                        button.style.fontWeight = '';
                    });
                    const targetId = this.getAttribute('data-bs-target');
                    const target = document.querySelector(targetId);
                    setTimeout(() => {
                        if (target && target.classList.contains('show')) {
                            this.style.backgroundColor = 'var(--bs-primary-bg-subtle)';
                            this.style.fontWeight = 'bold'
                        } else {
                            this.style.backgroundColor = '';
                            this.style.fontWeight = '';
                        }
                    }, 500);
                });
            });
        }, 3000);
        const siumQuery = query(collection(db, "siumim"), where("displayId", "==", params.displayId));
        getDocs(siumQuery).then(snapshot => {
            if (!snapshot.empty) {
                const siumDoc = snapshot.docs[0];
                setSium({ ...siumDoc.data(), id: siumDoc.id });
                const isAdmin = Cookies.get('siumShasId') === siumDoc.id;
                setIsAdmin(isAdmin);
            } else {
                navigate("/");
            }
        });
    },[params.displayId]);

    useEffect(() => {
        if (sium.masehtotSelection) {
            let usersList = {};
            let pagesWereLeanred = 0;
            let pagesWereTaken = 0;
            let handleUpdateSium = false;
            let siumStatus = {};
            const startD = sium.startSium?.toDate();
            const endD = sium.endSium?.toDate();
            const weeksNum = Math.round((endD - startD) / (7 * 24 * 60 * 60 * 1000));
            const overWeeksNum = Math.round((new Date() - startD) / (7 * 24 * 60 * 60 * 1000));
            const recommendedPercent = Math.min(100, Math.max(0, Math.floor((overWeeksNum / weeksNum) * 100)));

            for (const masehetKey of Object.keys(sium.masehtotSelection)
                .sort((a, b) => globalMasehtot.allMasehtot[a].index - globalMasehtot.allMasehtot[b].index)) {
                let chapterIndex = 0;
                siumStatus[masehetKey] = {};
                siumStatus[masehetKey]["chapters"] = [];
                for (const chapter of globalMasehtot.allMasehtot[masehetKey].chapters) {
                    if (globalMasehtot.allMasehtot[masehetKey].isMishna) {
                        siumStatus[masehetKey]["isMishna"] = true;
                        let chapterMishnayot = [];
                        for (let index=0; index < chapter; index++) {
                            chapterMishnayot.push({mishnaName: globalMasehtot.allMishnayot[index], learned: false});
                        }
                        siumStatus[masehetKey]["chapters"].push({
                            mishnayot: chapterMishnayot,
                            wasTaken: sium.masehtotSelection[masehetKey][chapterIndex],
                        });
                    } else {
                        let chapterPages = [];
                        const startIndex = globalMasehtot.onlyPages.indexOf(chapter.startPage.replace(/[.:]/g, ""));
                        const endIndex = globalMasehtot.onlyPages.indexOf(chapter.endPage.replace(/[.:]/g, ""));
                        for (let index = startIndex; index <= endIndex; index++) {
                            chapterPages.push({pageName: globalMasehtot.onlyPages[index], learned: false});
                        }
                        siumStatus[masehetKey]["chapters"].push({
                            pages: chapterPages,
                            wasTaken: sium.masehtotSelection[masehetKey][chapterIndex]
                        });
                    }
                    chapterIndex++;
                }
                siumStatus[masehetKey]["totalChapters"] = sium.masehtotSelection[masehetKey].length;
                siumStatus[masehetKey]["masehetIndex"] = globalMasehtot.allMasehtot[masehetKey].index;
                siumStatus[masehetKey]["usersList"] = [];
            }


            const q = query(collection(db, "users"), where("siumId", "==", sium.id));
            getDocs(q).then(users => {
                users.forEach((user) => {
                    const userObj = user.data();
                    let userPagesTaken = 0;
                    let userPagesLearned = 0;
                    let userMasehtot = [];
                    for (const masehet of userObj.masehtot) {
                        const masehetKey = masehet.masehetId;
                        let userChapters = [];
                        for (const chapter of masehet.chapters) {
                            const chapterIndex = parseInt(chapter.chapterNum) - 1;
                            let chapterWasLearned = false;
                            const properChapter = siumStatus[masehetKey]["chapters"][chapterIndex];
                            if (siumStatus[masehetKey]["isMishna"]) {
                                for (let i = 0; i < chapter.finish.length; i++) {
                                    if (i < siumStatus[masehetKey]["chapters"][chapterIndex]["mishnayot"].length) {
                                        siumStatus[masehetKey]["chapters"][chapterIndex]["mishnayot"][i].learned = chapter.finish[i];
                                    }
                                }
                                chapterWasLearned = chapter.finish.every((page) => page);
                                userChapters.push({[chapterIndex]: chapterWasLearned});
                                if (properChapter.user) {
                                    if (!properChapter["wasLearned"] && chapterWasLearned) {
                                        pagesWereLeanred += 1;
                                        properChapter["user"] = user.id;
                                        properChapter["wasLearned"] = chapterWasLearned;
                                    }
                                } else {
                                    pagesWereTaken += 1;
                                    if (chapterWasLearned) {
                                        pagesWereLeanred += 1;
                                    }
                                }
                                userPagesTaken += 1;
                                if (chapterWasLearned) {
                                    userPagesLearned += 1;
                                }
                            } else {
                                const partialLearned = properChapter["user"] && siumStatus[masehetKey]["chapters"][chapterIndex]["pages"].some((page) => page.learned);
                                for (let i = 0; i < chapter.finish.length; i++) {
                                    if (i < siumStatus[masehetKey]["chapters"][chapterIndex]["pages"].length) {
                                        siumStatus[masehetKey]["chapters"][chapterIndex]["pages"][i].learned = chapter.finish[i];
                                    }
                                }
                                const chapterPagesLearned = chapter.finish.filter((page) => page).length;
                                chapterWasLearned = chapterPagesLearned === chapter.finish.length;
                                userChapters.push({[chapterIndex]: chapterWasLearned});
                                if (properChapter.user) {
                                    if (!partialLearned && chapterPagesLearned > 0) {
                                        pagesWereLeanred += chapterPagesLearned;
                                        properChapter["user"] = user.id;
                                        properChapter["wasLearned"] = chapterWasLearned;
                                    }
                                } else {
                                    pagesWereTaken += chapter.finish.length;
                                    pagesWereLeanred += chapterPagesLearned;
                                }
                                userPagesTaken += chapter.finish.length;
                                userPagesLearned += chapterPagesLearned;
                            }

                            if (properChapter && !properChapter.wasTaken) {
                                handleUpdateSium = true;
                                properChapter.wasTaken = true;
                            }
                            if (!properChapter.user) {
                                properChapter["user"] = user.id;
                                properChapter["wasLearned"] = chapterWasLearned;
                            }
                        }
                        siumStatus[masehetKey]["usersList"].push(user.id);
                        userMasehtot.push({masehetKey: masehetKey, chapters: userChapters});
                    }
                    usersList[user.id] = {
                        id: user.id,
                        name: userObj.fullName,
                        phone: userObj.phone,
                        email: userObj.email,
                        userPagesTaken: userPagesTaken,
                        userPagesLearned: userPagesLearned,
                        masehtot: userMasehtot,
                        recommendedPercent: recommendedPercent,
                        lastModified: getLastModifiedInDays(userObj.lastModified)
                    };
                });

                setPagesWereLearned(pagesWereLeanred);
                setPagesWereTaken(pagesWereTaken);
                setSiumChapters(handleSiumChapters(siumStatus, usersList));

                setSiumUsers(handleLearningList(siumStatus, usersList, "status"));
                setSiumStatus(siumStatus);
                setUsersList(usersList);
            });
        }
    }, [sium]);

    if (sium && sium.kehilaName && globalMasehtot.allMasehtot) {
        const today = new Date();
        const endD = sium.endSium?.toDate();
        const daysNum = Math.round((endD - today) / (24 * 60 * 60 * 1000));
        return(
            <>
                {!printMode && <div className="sium-main">
                    <div className="sium-main-container">
                        <div className="basad-with-return">
                            <div className="basad">
                                <span>בס"ד</span>
                                <br/>
                                <span>להצלחת עם ישראל</span>
                            </div>
                            {isAdmin && <div className="return-container">
                                <a className="btn sium-button return-button"
                                   href={"/niulSium/" + sium.id + "/siumStatus"}>חזור</a>
                            </div>}
                        </div>
                        <div className="sium-logo">
                            <a className="sium-logo-img" href={"/"} aria-label="Main page"></a>
                        </div>
                        <div className="grid p-3 text-primary-emphasis bg-primary-subtle border border-primary-subtle rounded-3 sium-titles">
                            {sium.nishmat && <span>הלימוד {sium.nishmat}</span>}
                            <h2>סיום הש"ס של {sium.kehilaName}</h2>
                            {sium.logo && <div alt="logo" className={sium.logo}/>}
                            {daysNum > 0 && <p className="bold days-left">נותרו עוד {daysNum} ימים</p>}
                        </div>
                        <div id="displayMasehtot" className="sium-status-options-container">
                            <div>
                                {pagesWereTaken < sium.pagesCounter && <div className="sium-status-option" onClick={() => window.location = "/addUser/" + sium.id} tabIndex={0}>
                                    <svg fill="#414a87" height="200px" width="200px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511.999 511.999"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M503.292,210.719H398.127l-2.721-33.724c-0.005-0.053-0.015-0.104-0.021-0.157c-0.003-0.031-0.007-0.062-0.01-0.092 l-8.003-99.08c-0.365-4.522-4.141-8.007-8.68-8.007H133.303c-4.537,0-8.314,3.484-8.68,8.007l-2.457,30.415 c-0.387,4.794,3.185,8.994,7.979,9.381c4.807,0.389,8.993-3.185,9.381-7.979l1.81-22.408h229.323l6.617,81.912h-16.777 c-4.81,0-8.708,3.899-8.708,8.708s3.898,8.708,8.708,8.708h18.195l1.962,24.312H131.344l1.966-24.312h198.163 c4.81,0,8.708-3.899,8.708-8.708s-3.898-8.708-8.708-8.708H134.718l2.356-29.139c0.387-4.794-3.185-8.994-7.979-9.381 c-4.803-0.385-8.994,3.186-9.381,7.979l-5.845,72.273H8.708c-4.809,0-8.708,3.899-8.708,8.708s3.899,8.708,8.708,8.708h101.747 c-1.457,1.996-3.484,3.93-6.064,6.31c-6.083,5.611-14.414,13.295-14.414,27.819c0,14.525,8.331,22.209,14.414,27.82 c5.787,5.339,8.807,8.43,8.807,15.019c0,6.588-3.02,9.68-8.807,15.018c-6.083,5.611-14.414,13.295-14.414,27.82 s8.331,22.21,14.414,27.822c5.787,5.339,8.807,8.432,8.807,15.022c0,6.59-3.02,9.683-8.807,15.022 c-6.083,5.611-14.414,13.298-14.414,27.822c0,4.809,3.899,8.708,8.708,8.708s8.708-3.899,8.708-8.708 c0-6.59,3.02-9.682,8.807-15.022c6.083-5.611,14.414-13.297,14.414-27.822c0-14.525-8.331-22.211-14.414-27.822 c-5.787-5.339-8.807-8.432-8.807-15.022c0-6.588,3.02-9.681,8.807-15.019c6.084-5.611,14.414-13.295,14.414-27.819 c0-14.525-8.331-22.209-14.414-27.82c-5.787-5.339-8.807-8.43-8.807-15.019c0-6.588,3.02-9.68,8.807-15.018 c4.73-4.363,10.804-9.998,13.278-19.111h253.047c2.474,9.113,8.548,14.748,13.278,19.111c5.787,5.339,8.807,8.43,8.807,15.018 c0,6.589-3.02,9.681-8.807,15.019c-6.083,5.611-14.414,13.296-14.414,27.82s8.332,22.209,14.414,27.819 c5.787,5.339,8.807,8.43,8.807,15.019c0,6.59-3.02,9.682-8.807,15.022c-6.083,5.611-14.414,13.298-14.414,27.822 c0,14.525,8.332,22.211,14.414,27.822c5.787,5.339,8.807,8.432,8.807,15.022c0,4.809,3.898,8.708,8.708,8.708 c4.81,0,8.708-3.899,8.708-8.708c0-14.525-8.331-22.21-14.413-27.822c-5.788-5.339-8.808-8.432-8.808-15.022 c0-6.59,3.02-9.683,8.808-15.022c6.083-5.611,14.413-13.298,14.413-27.822s-8.332-22.209-14.414-27.82 c-5.787-5.339-8.807-8.43-8.807-15.018c0-6.589,3.02-9.681,8.807-15.019c6.083-5.611,14.414-13.296,14.414-27.82 c0-14.524-8.332-22.209-14.414-27.819c-2.58-2.38-4.607-4.315-6.064-6.31h101.747c4.81,0,8.708-3.899,8.708-8.708 S508.102,210.719,503.292,210.719z"></path> </g> </g> </g></svg>
                                    <span>הוסף לומד</span>
                                </div>}
                                <div className={`sium-status-option ${activeTab === 'takenMasehtot' ? 'active' : ''}`}
                                     onClick={() => setActiveTab('takenMasehtot')}
                                     aria-expanded={activeTab === 'takenMasehtot'} aria-controls="takenMasehtot" tabIndex={0}>
                                    <svg className="margin-right-10" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" fill="#414a87" stroke="#414a87"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>torah</title> <g id="torah"> <circle cx="8.5" cy="5.5" r="2.5" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></circle> <path d="M17,14V57.016A2.984,2.984,0,0,0,19.984,60H60V18H21a4.272,4.272,0,0,1-4-4.5h0A4.272,4.272,0,0,1,21,9H60" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></path> <line x1="60" y1="12" x2="34" y2="12" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></line> <line x1="37" y1="15" x2="23" y2="15" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></line> <line x1="40" y1="15" x2="44" y2="15" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></line> <line x1="60" y1="15" x2="53" y2="15" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></line> <polygon points="39 29 30.34 44 47.66 44 39 29" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></polygon> <polygon points="39 49 30.34 34 47.66 34 39 49" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></polygon> <line x1="20" y1="18" x2="20" y2="60" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></line> <path d="M28,60V56a4,4,0,0,1-4-4H20" style={{fill:"none",stroke:"#414a87",strokeLinejoin:"round",strokeWidth:"2px"}}></path> <path d="M28,18.355V22a4,4,0,0,0-4,4H20.308" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></path> <path d="M52,60V56a4,4,0,0,0,4-4h4" style={{fill:"none",stroke:"#414a87",strokeLinejoin:"round",strokeWidth:"2px"}}></path> <path d="M52,18v4a4,4,0,0,1,4,4h4" style={{fill:"none",stroke:"#414a87",strokeLinejoin:"round",strokeWidth:"2px"}}></path> <line x1="39" y1="25" x2="39" y2="23" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></line> <line x1="39" y1="53" x2="39" y2="55" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></line> <circle cx="11.044" cy="23.014" r="1.069"></circle> <line x1="7" y1="37" x2="10" y2="40" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></line> <line x1="10" y1="37" x2="7" y2="40" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></line> </g> </g></svg>
                                    <span>מצב הש"ס</span>
                                </div>
                                <div className={`sium-status-option ${activeTab === 'learningStatus' ? 'active' : ''}`}
                                     onClick={() => setActiveTab('learningStatus')}
                                     aria-expanded={activeTab === 'learningStatus'} aria-controls="learningStatus" tabIndex={0}>
                                    <svg height="200px" width="200px" version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="#414a87"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"><g> <path d="M6,7H0.9C0.4,7,0,7.4,0,7.9v9.1C0,17.6,0.4,18,0.9,18H6c1.7,0,3,1.3,3,3V10C9,8.3,7.7,7,6,7z"></path> <path d="M18.1,7H13c-1.7,0-3,1.3-3,3v11c0-1.7,1.3-3,3-3h5.1c0.5,0,0.9-0.4,0.9-0.9V7.9C19,7.4,18.6,7,18.1,7z"></path> </g> <path d="M31.9,17.6L29,11.8C28.9,6.4,24.4,2,19,2c-2.8,0-5.4,1.2-7.3,3.2C12.1,5.1,12.5,5,13,5h5.1C19.7,5,21,6.3,21,7.9v9.1 c0,1.6-1.3,2.9-2.9,2.9H13c-0.6,0-1,0.4-1,1v6c0,0.5,0.3,0.9,0.8,1l10,2c0.1,0,0.1,0,0.2,0c0.2,0,0.5-0.1,0.6-0.2 c0.2-0.2,0.4-0.5,0.4-0.8v-4h2c1.7,0,3-1.3,3-3v-3h2c0.3,0,0.7-0.2,0.9-0.5S32,17.9,31.9,17.6z"></path> </g></svg>
                                    <span>רשימת לומדים</span>
                                </div>
                            </div>
                            <div className={`collapse ${activeTab === 'takenMasehtot' ? 'show' : ''}`} id="takenMasehtot">
                                <div className="card card-body">
                                    <SiumProgress dapim={true} takenPages={Math.floor((pagesWereTaken/sium.pagesCounter) * 100)}
                                                  learnedPages={Math.floor((pagesWereLearned/sium.pagesCounter) * 100)}/>
                                    <div className="sium-status-btns">
                                        <button className="btn dark-button share-display-sium" onClick={() => setPrintMode(true)}>
                                            <span>הדפס מצב הש"ס</span>
                                        </button>
                                        <button className="btn dark-button share-display-sium" onClick={() => shareLomdimLoginPage()}>
                                            לינק כניסה ללומדים
                                        </button>
                                    </div>

                                    {/* Filter checkboxes */}
                                    <div className="masehtot-filter-container margin-top-10 margin-bottom-10">
                                        <label className="masehtot-filter-label">סינון:</label>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="filterStillFreeDetails"
                                                checked={filterStillFree}
                                                onChange={(e) => handleMasehtotFilterChange('stillFree', e.target.checked)}
                                            />
                                            <label className="form-check-label" htmlFor="filterStillFreeDetails">
                                                פנויות
                                            </label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="filterNotLearnedYetDetails"
                                                checked={filterNotLearnedYet}
                                                onChange={(e) => handleMasehtotFilterChange('notLearnedYet', e.target.checked)}
                                            />
                                            <label className="form-check-label" htmlFor="filterNotLearnedYetDetails">
                                                לא נלמדו
                                            </label>
                                        </div>
                                    </div>

                                    <div className="accordion" id="takenMasehtotList">
                                        {siumChapters}
                                    </div>
                                </div>
                            </div>
                            <div className={`collapse ${activeTab === 'learningStatus' ? 'show' : ''}`} id="learningStatus">
                                <div className="card card-body">

                                    <div className="btn-group sorting-container margin-bottom-10" role="group" aria-label="sort learining list buttons">
                                        <label className="sorting-label">מיין לפי:</label>
                                        <button
                                            type="button"
                                            className={`btn sort-button ${learningListSorting === "status" ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleSortChange("status")}
                                        >
                                            מצב למידה
                                            {learningListSorting === "status" && (
                                                <span className="sort-direction-icon">
                                                    {sortDirection === "asc" ? "▲" : "▼"}
                                                </span>
                                            )}
                                        </button>

                                        <button
                                            type="button"
                                            className={`btn sort-button ${learningListSorting === "date" ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleSortChange("date")}
                                        >
                                            תאריך עדכון
                                            {learningListSorting === "date" && (
                                                <span className="sort-direction-icon">
                                                    {sortDirection === "asc" ? "▲" : "▼"}
                                                </span>
                                            )}
                                        </button>

                                        <button
                                            type="button"
                                            className={`btn sort-button ${learningListSorting === "name" ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleSortChange("name")}
                                        >
                                            שם הלומד
                                            {learningListSorting === "name" && (
                                                <span className="sort-direction-icon">
                                                    {sortDirection === "asc" ? "▲" : "▼"}
                                                </span>
                                            )}
                                        </button>
                                    </div>

                                    {/* Search input */}
                                    <div className="learners-search-container margin-bottom-10">
                                        {!searchQuery && <span className="learners-search-icon">🔍</span>}
                                        <input
                                            type="text"
                                            className="form-control learners-search-input"
                                            placeholder="חיפוש לומד לפי שם, טלפון, אימייל..."
                                            value={searchQuery}
                                            onChange={(e) => handleSearch(e.target.value)}
                                        />
                                        {searchQuery && (
                                            <button
                                                type="button"
                                                className="learners-search-clear"
                                                onClick={() => handleSearch("")}
                                            >
                                                ✕
                                            </button>
                                        )}
                                    </div>

                                    <div className="accordion margin-top-20" id="learningUsersList">
                                        {siumUsers}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal fade" id="addUserModal" tabIndex="-1" aria-labelledby="add user" aria-hidden="true">
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h1 className="modal-title fs-5">הדף טרם נלקח</h1>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body sium-status-options-container add-user-modal">
                                        <span>תרצה להוסיף לומד חדש?</span>
                                        <div className="sium-status-option" onClick={() => window.location = "/addUser/" + sium.id} tabIndex={0}>
                                            <svg fill="#414a87" height="200px" width="200px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511.999 511.999"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M503.292,210.719H398.127l-2.721-33.724c-0.005-0.053-0.015-0.104-0.021-0.157c-0.003-0.031-0.007-0.062-0.01-0.092 l-8.003-99.08c-0.365-4.522-4.141-8.007-8.68-8.007H133.303c-4.537,0-8.314,3.484-8.68,8.007l-2.457,30.415 c-0.387,4.794,3.185,8.994,7.979,9.381c4.807,0.389,8.993-3.185,9.381-7.979l1.81-22.408h229.323l6.617,81.912h-16.777 c-4.81,0-8.708,3.899-8.708,8.708s3.898,8.708,8.708,8.708h18.195l1.962,24.312H131.344l1.966-24.312h198.163 c4.81,0,8.708-3.899,8.708-8.708s-3.898-8.708-8.708-8.708H134.718l2.356-29.139c0.387-4.794-3.185-8.994-7.979-9.381 c-4.803-0.385-8.994,3.186-9.381,7.979l-5.845,72.273H8.708c-4.809,0-8.708,3.899-8.708,8.708s3.899,8.708,8.708,8.708h101.747 c-1.457,1.996-3.484,3.93-6.064,6.31c-6.083,5.611-14.414,13.295-14.414,27.819c0,14.525,8.331,22.209,14.414,27.82 c5.787,5.339,8.807,8.43,8.807,15.019c0,6.588-3.02,9.68-8.807,15.018c-6.083,5.611-14.414,13.295-14.414,27.82 s8.331,22.21,14.414,27.822c5.787,5.339,8.807,8.432,8.807,15.022c0,6.59-3.02,9.683-8.807,15.022 c-6.083,5.611-14.414,13.298-14.414,27.822c0,4.809,3.899,8.708,8.708,8.708s8.708-3.899,8.708-8.708 c0-6.59,3.02-9.682,8.807-15.022c6.083-5.611,14.414-13.297,14.414-27.822c0-14.525-8.331-22.211-14.414-27.822 c-5.787-5.339-8.807-8.432-8.807-15.022c0-6.588,3.02-9.681,8.807-15.019c6.084-5.611,14.414-13.295,14.414-27.819 c0-14.525-8.331-22.209-14.414-27.82c-5.787-5.339-8.807-8.43-8.807-15.019c0-6.588,3.02-9.68,8.807-15.018 c4.73-4.363,10.804-9.998,13.278-19.111h253.047c2.474,9.113,8.548,14.748,13.278,19.111c5.787,5.339,8.807,8.43,8.807,15.018 c0,6.589-3.02,9.681-8.807,15.019c-6.083,5.611-14.414,13.296-14.414,27.82s8.332,22.209,14.414,27.819 c5.787,5.339,8.807,8.43,8.807,15.019c0,6.59-3.02,9.682-8.807,15.022c-6.083,5.611-14.414,13.298-14.414,27.822 c0,14.525,8.332,22.211,14.414,27.822c5.787,5.339,8.807,8.432,8.807,15.022c0,4.809,3.898,8.708,8.708,8.708 c4.81,0,8.708-3.899,8.708-8.708c0-14.525-8.331-22.21-14.413-27.822c-5.788-5.339-8.808-8.432-8.808-15.022 c0-6.59,3.02-9.683,8.808-15.022c6.083-5.611,14.413-13.298,14.413-27.822s-8.332-22.209-14.414-27.82 c-5.787-5.339-8.807-8.43-8.807-15.018c0-6.589,3.02-9.681,8.807-15.019c6.083-5.611,14.414-13.296,14.414-27.82 c0-14.524-8.332-22.209-14.414-27.819c-2.58-2.38-4.607-4.315-6.064-6.31h101.747c4.81,0,8.708-3.899,8.708-8.708 S508.102,210.719,503.292,210.719z"></path> </g> </g> </g></svg>
                                            <span>הוסף לומד</span>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">ביטול</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal fade" id="checkUserModal" tabIndex="-1" aria-labelledby="check user details" aria-hidden="true">
                            {checkUserDetails && <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h1 className="modal-title fs-5">
                                            {checkUserDetails.name}
                                            <span className="badge bg-primary margin-right-10">
                                                {checkUserDetails.userPagesLearned}/{checkUserDetails.userPagesTaken} דפים נלמדו
                                            </span>
                                        </h1>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                </div>
                            </div>}
                        </div>
                        <div className="sium-bottom-page">
                            <span> © כל הזכויות שמורות לאתר סיום הש"ס</span>
                        </div>
                    </div>
                    {pagesWereLearned === sium.pagesCounter && <ConfettiComponent></ConfettiComponent>}
                </div>}
                {printMode && <PrintMasehtot siumStatus={siumStatus} usersList={usersList} pagesWereTaken={pagesWereTaken}
                                             pagesWereLearned={pagesWereLearned} sium={sium} back={setPrintMode}></PrintMasehtot>}
            </>
        )
    } else {
        return (<Spinner/>);
    }



}
export default DisplaySiumDetails;
